import { useEffect } from 'react';

/* «Не гасить экран» (P1): пока открыта тренировка, телефон не засыпает.
   Screen Wake Lock API — Safari и Chrome на телефоне, только пока страница
   видна; при возврате во вкладку блокировку берём заново. */
type Sentinel = { release: () => Promise<void> };
export function useWakeLock(on: boolean) {
  useEffect(() => {
    const wl = (navigator as Navigator & { wakeLock?: { request: (t: 'screen') => Promise<Sentinel> } }).wakeLock;
    if (!on || !wl) return;
    let s: Sentinel | null = null;
    let alive = true;
    const take = () => {
      if (document.visibilityState !== 'visible') return;
      wl.request('screen')
        .then((x) => {
          if (alive) s = x;
          else x.release().catch(() => {});
        })
        .catch(() => {});
    };
    take();
    document.addEventListener('visibilitychange', take);
    return () => {
      alive = false;
      document.removeEventListener('visibilitychange', take);
      s?.release().catch(() => {});
    };
  }, [on]);
}
